import { useQuery } from '@apollo/client';

import { GET_MY_ADVERTISEMENTS } from 'schemas';

import {
  IUseGetMyAdvertisementsParams,
  IUseGetMyAdvertisementsReturn,
} from './interfaces';

export const useGetMyAdvertisements = (
  params?: IUseGetMyAdvertisementsParams
): IUseGetMyAdvertisementsReturn => {
  const { data, loading } = useQuery(GET_MY_ADVERTISEMENTS, {
    variables: params,
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true,
    skip: params?.skip,
  });

  return {
    advertisements: data?.getMyAdvertisements?.data ?? [],
    paginator: data?.getMyAdvertisements?.paginatorInfo,
    loading,
  };
};
